import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type OrganisationContract from "./OrganisationContract";

@Model()
class OrganisationContractService extends ApplicationRecord {
  static jsonapiType = "organisation_contract_services";

  @Attr() billingCycle: string;

  @Attr() billMonthInAdvance: boolean;

  @Attr() expectedReportDeliveries: number;

  @Attr() invoiceDescription: string;

  @HasOne() organisationContract: OrganisationContract;

  @Attr() organisationContractId: number;

  @Attr() overrideBillingCycle: boolean;

  @Attr({ persist: false }) priceIncludingTax: number;

  @Attr() pricePerMonth: number;

  @Attr() reportFirstDeliveryDate: string;

  @Attr() reportFrequencyDelivery: string;

  @Attr() service: string;

  @Attr({ persist: false }) taxAmount: number;
}

export default OrganisationContractService;
